import React from 'react';
const BottomDisclaimer = () => {
  return (
    <p className='BottomDisclaimer'>
      לידיעתך, יתכן וחלק מהנתונים עדיין לא התקבלו מהמפעילים הסלולריים בחו"ל. המידע הסופי הינו בחשבונית החודשית.
      <br />
      באיזור זה ניתן לצפות בשימושים שנעשו במחזור חיוב הנוכחי או הקודם. למידע על תקופות מוקדמות יותר יש לצפות בחשבונית עבור החודש הרלוונטי.
    </p>
  );
};

export default BottomDisclaimer;
